<template>
  <div ref="scrollContainer" class="main-container">

    <!-- Hero Section -->
    <section v-if="$store.state.apperance_slider == 1" id="hero" class="hero-section">
      <div v-if="loadingSlider" class="loading-wrapper">
        <img src="/assets/image/loading_store.gif"  alt="Loading..." class="gif-loader" />
      </div>
      <div class="container">
        <div class="row mt-4">
          <div v-if="!loadingSlider && sliders?.length" class="col-lg-12">
            <carousel :per-page="1" :mouse-drag="false" autoplay loop :autoplayTimeout="5000" :paginationEnabled="false">
              <slide v-for="(item, idx) in sliders" :key="idx">
                <div class="slider-card">
                  <h1 v-if="item.title" class="slider-title">{{ item.title }}</h1>
                  <div v-if="item.description" class="slider-description" v-html="item.description"></div>
                  <h6 v-if="item.sub_title" class="slider-subtitle">{{ item.sub_title }}</h6>
                </div>
                <img :src="item.image" @click="item.value ? sliderLink(item.value) : null" class="slider-image" />
              </slide>
            </carousel>
          </div>
        </div>
      </div>
    </section>

    <!-- Latest Products Section -->
    <section v-if="$store.state.apperance_latest_products == 1" id="fiveth" class="product-section">
      <div class="container">
        <div class="section-title d-flex justify-content-between">
          <h2>{{ $t("products") }}</h2>
        </div>

        <!-- عند تحميل المنتجات لأول مرة -->
        <div v-if="loadingProducts" class="loading-wrapper">
          <img src="/assets/image/loading_store.gif" alt="Loading..." class="gif-loader" />
        </div>

        <!-- عرض المنتجات -->
        <div v-if="!loadingProducts" class="row mt-2">
          <div class="col2 col-lg-3 col-6 mb-5" v-for="(item, index) in products" :key="index">
            <card3 v-bind="item" :productid="item.id" />
          </div>
        </div>

        <!-- تحميل المزيد عند عدم الانتهاء -->
        <div v-if="loadingMore" class="loading-wrapper">
          <img src="/pet_shop/assets/images/ajax-loader.gif" alt="Loading More..." class="gif-loader" />
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import card3 from "../components/CardStyle3.vue";
import { Carousel, Slide } from "vue-carousel";

export default {
  name: "CarouselPage",
  components: { card3, Carousel, Slide },
  data() {
    return {
      sliders: [],
      products: [],
      page: 1,
      loadingSlider: true,
      loadingProducts: false,
      loadingMore: false,
      allProductsLoaded: false
    };
  },
  created() {
    this.setMetaTags();
    this.fetchSliders();
    this.fetchProducts();
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    setMetaTags() {
      const { title_ar, description_ar, keyword_ar, title_en, description_en, keyword_en } = this.$store.state;
      const isArabic = this.$i18n.locale == "ar";
      document.title = isArabic ? title_ar : title_en;
      document.getElementById("description_meta").content = isArabic ? description_ar : description_en;
      document.getElementById("keywords_meta").content = isArabic ? keyword_ar : keyword_en;
    },
    fetchSliders() {
      if (this.$store.state.apperance_slider !== 1) return;
      this.loadingSlider = true;
      this.axios.get(`${this.$store.state.base_api_url}${this.$store.storeName}/sliders`)
        .then(res => { this.sliders = res.data.data.sliders; })
        .finally(() => { this.loadingSlider = false; });
    },
    fetchProducts() {
      if (this.$store.state.apperance_best_saller !== 1) return;
      this.loadingProducts = true;
      this.axios.post(`${this.$store.state.base_api_url}${this.$store.storeName}/random_products`, {}, {
        headers: {
          "Accept-Language": this.$i18n.locale,
          Authorization: `Bearer ${this.$localStorage.get(this.$store.storeName)}`
        }
      }).then(res => { this.products = res.data.data.products; })
        .finally(() => { this.loadingProducts = false; });
    },
    loadMore() {
      if (this.loadingMore || this.allProductsLoaded) return;
      this.page++;
      this.loadingMore = true;
      this.axios.post(`${this.$store.state.base_api_url}${this.$store.storeName}/random_products?page=${this.page}`, {}, {
        headers: {
          "Accept-Language": this.$i18n.locale
        }
      }).then(res => {
        const newProducts = res.data.data.products;
        if (!newProducts.length) {
          this.allProductsLoaded = true;
        } else {
          this.products.push(...newProducts);
        }
      }).finally(() => {
        this.loadingMore = false;
      });
    },
    handleScroll() {
      const productsSection = document.querySelector('.product-section .row');
      if (!productsSection) return;
      const sectionTop = productsSection.getBoundingClientRect().top + window.scrollY;
      const sectionHeight = productsSection.offsetHeight;
      const quarterPoint = sectionTop + sectionHeight / 4;
      if (window.scrollY + window.innerHeight >= quarterPoint && !this.loadingMore && !this.allProductsLoaded) {
        this.loadMore();
      }
    },
    sliderLink(link) {
      if (link) window.location.href = link;
    },
    updatedata() {
      this.fetchSliders();
      this.fetchProducts();
      this.$store.state.langchange = false;
    }
  },
  watch: {
    langChange() {
      this.setMetaTags();
      this.fetchSliders();
      this.page = 1;
      this.fetchProducts();
    }
  },
  updated() {
    this.langChange = this.$i18n.locale;
  }
};
</script>

<style scoped>
.main-container {
  background-color: #fefefe;
  min-height: 600px;
}
.loading-wrapper {
  display: flex;
  justify-content: center;
  margin-top: 100px;
}
.gif-loader {
  width: 80px;
  height: 80px;
}
.slider-card {
  text-align: left;
  padding: 10px;
}
.slider-title, .slider-subtitle {
  animation: fadeIn 1s ease-in;
}
.slider-image {
  width: 100%;
  border-radius: 15px;
}
.hero-section {
  background-image: url("../../public/assets/image/background.png");
  background-repeat: no-repeat;
  background-position: 100% 80%;
  margin-top: 50px;
  padding-bottom: 0;
}
</style>
